export default __webpack_public_path__ + "static/media/icon-discounts-coupon.1eb31150.svg";